import { callAPI, basePath } from './common'
import { CompanyDownloadInfoData } from '../../types/api'

export const getCompanyDownloadInfo = () => {
  return callAPI<CompanyDownloadInfoData>(`${basePath}/users/company_download`)
}
